import React from "react"
import Layout from "../../components/layout"
import FreeTrialStrip from "../../components/layoutComponents/FreeTrialStrip"
import HeroVideo from "../../components/layoutComponents/HeroVideo"
import AdvancedTiming from "../../components/layoutComponents/platform/automation/AdvancedTiming"
import BuildHighConvertingSequences from "../../components/layoutComponents/platform/automation/BuildHighConvertingSequences"
import BuiltInLogic from "../../components/layoutComponents/platform/automation/BuiltInLogic"
import FlexibleCommunication from "../../components/layoutComponents/platform/automation/FlexibleCommunication"
import PowerfulActions from "../../components/layoutComponents/platform/automation/PowerfulActions"
import TargetPrecisely from "../../components/layoutComponents/platform/automation/TargetPrecisely"
import Testimonials from "../../components/layoutComponents/Testimonials"
import AutomationHeaderImage from "../../components/staticQuery/platform/automation/AutomationHeaderImage"
import { babyBlueColor } from "../../theme"
import P from "../../components/typography/P"

const seo = {
  title: "Marketing Automation",
  description:
    "Learn about what you can do with MindMe's built-in marketing automation features.",
}

const Description = () => (
  <>
    <P>
      When you want to convert leads, engage customers or do anything in
      between, Automation Sequences do the heavy lifting. Create a series of
      steps that are performed at just the right time to drive higher engagement
      and results.
    </P>
    <P>
      Automation Sequences can start and stop automatically, and include emails,
      text messages, actions, delays and branching. Use them to sell more
      products and services, promote events, deliver birthday Offers and so much
      more!
    </P>
    <P>
      <strong>Set it and forget it</strong>
    </P>
  </>
)

const header = (
  <HeroVideo
    title="Marketing Automation"
    description={<Description />}
    media={<AutomationHeaderImage />}
    tint={babyBlueColor}
    clipPath="polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 6vw))"
  />
)

const main = (
  <>
    <TargetPrecisely />
    <BuiltInLogic />
    <AdvancedTiming />
    <PowerfulActions />
    <FlexibleCommunication />
    <BuildHighConvertingSequences />
    <FreeTrialStrip />
    <Testimonials />
  </>
)

const AutomationPage = () => <Layout header={header} main={main} seo={seo} />

export default AutomationPage
